/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");
var xtend = require("xtend");

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedbracelet",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_group: null,
	_who_tracker: null,
	_people: null,

	refresh: refresh,
	reset: reset,
	sayViewing: sayViewing,
	recalculateContact: recalculateContact,
	stop_scanning: stop_scanning,
});

function init() {
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker();

	this.reset();
}

/**
 * Removes all listeners from the dispatcher and the people store
 */
function uninit() {
	this._who = null;
	this._who_tracker.off(); //Ensures all trackers off off to ensure 'clean' start.
	this._who_tracker = null;
}

function listeners() {
	return {
		"people:updated": handle_people_updated,
		"connectivity:online": refresh,
	};
}

function triggers() {
	return {
		"update": update,
		"associate": associate,
		"unassociate": unassociate,
		"contact": contact,
		"choose": trigger_choose_contact,
		"choose:cancel": trigger_choose_contact_cancel,
		"scan:start": start_scanning,
		"scan:stop": stop_scanning,
		"view": view,
		"reset": trigger_reset,
	};
}

function view(data) {
	const { who, group } = data;

	if(who === this._who){
		this.sayViewing();
		return;
	}

	var managee = this._people[who];

	if (!managee) return; // Don't bother tracking if they don't exist
	if (managee.type.indexOf("device") === -1) return; // Don't try to load if they don't have the permissions

	this.reset(); // Clear any state that was there before

	this.emit("managedcontacts:trigger:load", data);

	// Track ID and group of person being managed
	this._who = who;
	this._group = group;

	var tracker = this._who_tracker;

	// Listen to changes in this person's data

	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/device/updated", handle_update.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/device/mac/updated", handle_mac_update.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/device/mac/unassigned", handle_mac_unassign.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/device/scan/scanned", handle_scanned.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/device/scan/connected", handle_connected.bind(this));
	} else {
		tracker.on("mqtt:u/" + who + "/device/updated", handle_update.bind(this));
		tracker.on("mqtt:u/" + who + "/device/mac/updated", handle_mac_update.bind(this));
		tracker.on("mqtt:u/" + who + "/device/mac/unassigned", handle_mac_unassign.bind(this));
		tracker.on("mqtt:u/" + who + "/device/scan/scanned", handle_scanned.bind(this));
		tracker.on("mqtt:u/" + who + "/device/scan/connected", handle_connected.bind(this));
	}

	// Fetch the latest data
	this.refresh().then(sayViewing.bind(this));

	this.emit("usermetrics:trigger:track", "view managed user's bracelet settings", {
		who: this._who,
	});
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who
	});
}

function update(data) {

	var managee = this._who;
	const group = this._group;

	var payload = xtend(data, {
		relay: !!data.relay
	});

	this.emit("save:trigger:start");
	this.api.manage.device.update(managee, payload, group)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));

	this.emit("usermetrics:trigger:track", "update managed user's bracelet settings", {
		who: managee
	});
}

function associate(data) {
	var mac = data.mac;
	var managee = this._who;
	const group = this._group;
	this.api.manage.device.associate(managee, mac, group)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
	this.emit("usermetrics:trigger:track", "add bracelet mac to managed user", {
		who: managee
	});
}

function unassociate() {
	var managee = this._who;
	const group = this._group;
	this.api.manage.device.unassociate(managee, group)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
	this.emit("usermetrics:trigger:track", "remove bracelet mac from managed user", {
		who: managee
	});
}

function contact(data) {
	var contactId = data.who;
	var managee = this._who;
	const group = this._group;
	this.api.manage.device
		.contact(managee, contactId, group)
		.then(handle_contact_update_success.bind(this))
		.catch(handle_update_error.bind(this));
	this.emit("usermetrics:trigger:track", "update managed user's bracelet contact", {
		who: managee
	});
}

function trigger_choose_contact() {
	this.extend({
		choosing_contact: true,
		updating: false,
		updated_success: false,
		update_error: false
	});
	this.emit("usermetrics:trigger:track", "open choose managed user's bracelet contact popup", {
		who: this._who
	});
}

function trigger_choose_contact_cancel() {
	this.extend({
		choosing_contact: false,
		updating: false,
		updated_success: false,
		update_error: false
	});
	this.emit("usermetrics:trigger:track", "close choose managed user's bracelet contact popup", {
		who: this._who
	});
}

function start_scanning() {
	var who = this._who;
	var group = this._group;

	if(group)
		this.emit("$mqtt:managegroup/" + group + "/patient/u/" + who + "/device/scan/start", {
			from: this.config.id
		});
	else
		this.emit("$mqtt:u/" + who + "/device/scan/start", {
			from: this.config.id
		});
	this.extend({
		scanning: true
	});
	this.emit("usermetrics:trigger:track", "start bluetooth scan for managed user's bracelet", {
		who: this._who
	});
}

function stop_scanning() {
	var who = this._who;
	var group = this._group;
	if(group)
		this.emit("$mqtt:managegroup/" + group + "/patient/u/" + who + "/device/scan/stop", {
			from: this.config.id
		});
	else
		this.emit("$mqtt:u/" + who + "/device/scan/stop", {
			from: this.config.id
		});
	this.extend({
		scanning: false,
		scanned_devices: []
	});
}

function handle_contact_update_success() {
	this.extend({
		choosing_contact: false,
		updating: false,
		updated_success: false,
		update_error: false
	});
}

function handle_update_success() {
	this.extend({
		updating: false,
		updated_success: true,
		update_error: false
	});
	var message = "managedbracelet.saved";
	this.emit("toast:trigger:show", {
		content: message
	});

	this.stop_scanning();
	this.emit("save:trigger:finish");

	this.dispatch("newbraceletsettings", {
		who: this._who,
		section: "device",
		timestamp: new Date().toISOString(),
	});

	setTimeout(clearErrorAndSave.bind(this), 5 * 1000);
}

function clearErrorAndSave() {
	this.extend({
		updating: false,
		updated_success: false,
		update_error: false
	});
}

function handle_update_error(error) {
	console.error(error);
	this.extend({
		updating: false,
		updated_success: false,
		update_error: true
	});
	this.emit("save:trigger:finish");
	var message = "managedbracelet.error";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function trigger_reset(){
	this.emit("usermetrics:trigger:track", "close managed user's bracelet settings", {
		who: this._who
	});
	this.reset();
	this.emit("managedcontacts:trigger:reset");
	this.dispatch("newbraceletsettings", {
		who: this._who,
		section: "device",
		timestamp: new Date().toISOString(),
	});
}

function reset() {
	var who = this._who;
	var group = this._group;
	if (who && this.data && this.data.scanning){
		if(group)
			this.emit("$mqtt:managegroup/" + group + "/patient/u/" + who + "/device/scan/stop");
		else
			this.emit("$mqtt:u/" + who + "/device/scan/stop");
	}

	this._who = null;
	this._who_tracker.off();
	this._group = null;

	this.push({
		choosing_contact: false,
		updating: false,
		update_error: false,
		updated_success: false,
		scanned_devices: [],
		scanning: false,
		connected_to: "",
	});
}

function refresh() {
	var managee = this._who;
	const group = this._group;
	if (!managee) return;
	this.emit("save:trigger:start");
	return this.api.manage.device
		.data(managee, group)
		.then(handle_update.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function handle_update(data) {
	this.extend(data);

	var contactId = data.contact;
	if (!contactId) return;

	this.emit("people:trigger:add", {
		lean: true,
		who: contactId
	});

	this.recalculateContact();
}

function handle_mac_update(data) {
	var mac = data.mac;
	this.extend({
		mac: mac
	});
}

function handle_mac_unassign() {
	this.extend({
		mac: null
	});
}

function handle_scanned(device) {
	var scanned = this.data.scanned_devices;
	var alreadyFound = false;

	scanned = scanned.map(function (existing) {
		if (existing.id !== device.id) return existing;
		alreadyFound = true;
		return device;
	});

	if (!alreadyFound)
		scanned = scanned.concat(device);

	this.extend({
		scanned_devices: scanned
	});
}

function handle_connected(data) {
	var mac = data.mac;
	this.extend({
		scanning: false,
		scanned_devices: [],
		connected_to: mac,
	});
}

function recalculateContact() {
	var people = this._people;

	var contactId = this.data.contact;
	var contactData = people[contactId];
	if (!contactData) return;

	this.extend({
		contactData: contactData
	});
}

function handle_people_updated(people) {
	this._people = people;

	this.recalculateContact();
}
